import { useState } from "react";
import { currentTheme, toggleTheme, type Theme } from "../../lib/theme.ts";
import { IconButton } from "./IconButton.tsx";

export function ThemeToggle() {
  const [theme, setTheme] = useState<Theme>(currentTheme());
  return (
    <IconButton
      onClick={() => setTheme(toggleTheme())}
      aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
      title="Toggle theme"
    >
      {theme === "dark" ? "☀" : "☾"}
    </IconButton>
  );
}
